<template>
	<div>
		<CRow class="justify-content-center">
			<!-- explicacion de como crear una solicitud -->
			<CCol v-if="showProcessExplanation" sm="12" class="">
				<CCard>
					<CCardHeader style="background: #97ca3d; color: black;">
						<h3>
							¿Como crear un envío masivo?
						</h3>
					</CCardHeader>
					<CCardBody>
						<CRow>
							<CCol sm="12">
								<p>
									Para crear un envío masivo debes primero
									seleccionar una categoría.
								</p>
								<p>
									Una vez selecciones la categoría debes
									indicar si el envío es
									<b
										>nacional, por estado, por ciudad o por
										urbanización</b
									>.
								</p>
								<h5>
									<i class="fas fa-hand-point-right"></i>
									Envío Nacional
								</h5>
								<p>
									Al realizar un envío <b>Nacional</b> se
									realizara a todas las empresas a nivel
									nacional de la categoría previamente
									seleccionada.
								</p>
								<h5>
									<i class="fas fa-hand-point-right"></i>
									Envío por Estado
								</h5>
								<p>
									Al realizar un envío por
									<b>Estado</b> podrás seleccionar uno o más
									estados.
								</p>
								<h5>
									<i class="fas fa-hand-point-right"></i>
									Envío por Ciudad
								</h5>
								<p>
									Al realizar un envío por
									<b>Ciudad</b> deberás primero sleccionar un
									estado y luego podrás seleccionar una o mas
									ciudades del estado previamente
									seleccionado.
								</p>
								<h5>
									<i class="fas fa-hand-point-right"></i>
									Envío por Urbanización
								</h5>
								<p>
									Al realizar un envío por
									<b>Urbanización</b> deberás primero
									sleccionar un estado seguido de una ciudad
									del estado seleccionado previamente, luego
									podrás seleccionar una o mas urbanizaciones.
								</p>
								<p>
									Una vez culmines el proceso de seleccionar
									los filtros necesarios para el envío podrás
									finalizar el proceso de programar el envío
									el cual se ejecutará de forma automática al
									día siguiente.
								</p>
								<p>
									Puedes ocultar esta explicación para
									continuar creando el envío haciendo clic en
									el siguiente botón.
								</p>
								<b-button
									@click="showProcessExplanation = false"
									title="Eliminar Usuario"
									id="infoProcess"
									pill
									variant="info"
								>
									Gracias por la explicación !!
								</b-button>
							</CCol>
						</CRow>
					</CCardBody>
				</CCard>
			</CCol>
			<CCol
				v-else-if="!showProcessExplanation && !showDetail"
				sm="12"
				class=""
			>
				<CCard>
					<CCardHeader style="background: #97ca3d; color: black;">
						<h3>
							Crear Envío Masivo
						</h3>
					</CCardHeader>
					<CCardBody>
						<CRow>
							<CCol sm="12">
								<p>
									En este modulo puedes crear un envío masivo
									para solicitar a las empresas registradas en
									<b>Infoguia</b> que actualicen sus datos si
									asi lo desean.
								</p>
							</CCol>
							<CCol sm="12">
								<p>
									Si no sabes como crear un envío masivo
									puedes hacer clic en el siguiente botón para
									ver una breve explicación del proceso.
								</p>
								<b-button
									@click="showProcessExplanation = true"
									title="Eliminar Usuario"
									id="infoProcess"
									pill
									variant="info"
								>
									Quiero ver la explicación !!
								</b-button>
							</CCol>
						</CRow>
						<br />
						<!-- selects para los filtros del tipo de envio -->
						<CRow class="content-left">
							<!-- select para las categorias -->
							<CCol
								v-if="allCategories != null"
								sm="4"
								class="content-left"
							>
								<div role="group" class="form-group">
									<label for="urb">Categoría</label>
									<multiselect
										v-model="selectedCategorie"
										track-by="codigocategoria"
										label="nombrecategoria"
										:options="allCategories"
										:searchable="true"
										:close-on-select="true"
										:show-labels="false"
										:allow-empty="true"
										placeholder="Seleccione"
									>
										<span slot="noResult"
											>Oops! No se encontró la opción
											deseada</span
										>
									</multiselect>
								</div>
							</CCol>
							<!-- select para el tipo de envio -->
							<CCol
								v-if="selectedCategorie != null"
								sm="3"
								class="content-left"
							>
								<div role="group" class="form-group">
									<label for="urb">Tipo de filtro</label>
									<multiselect
										@select="changeMethodMasiveEmail"
										v-model="selectedMethodRequest"
										track-by="typeCod"
										label="nameType"
										:options="methodMasiveRequest"
										:searchable="false"
										:close-on-select="true"
										:show-labels="false"
										:allow-empty="true"
										placeholder="Seleccione"
									>
										<span slot="noResult"
											>Oops! No se encontró la opción
											deseada</span
										>
									</multiselect>
								</div>
							</CCol>
							<!-- select para los estados -->
							<CCol
								v-if="optionsSelectStates.showSelectStates"
								sm="5"
								class="content-left"
							>
								<div role="group" class="form-group">
									<label for="states">Estados</label>
									<multiselect
										@select="changeSelectState"
										:multiple="optionsSelectStates.multiple"
										v-model="selectedState"
										track-by="codigoestado"
										label="nombreestado"
										:options="allStates"
										:searchable="true"
										:close-on-select="true"
										:show-labels="false"
										:allow-empty="true"
										placeholder="Seleccione"
									>
										<span slot="noResult"
											>Oops! No se encontró la opción
											deseada</span
										>
									</multiselect>
								</div>
							</CCol>
							<!-- select para las ciudades -->
							<CCol
								v-if="
									optionsSelectCities.showSelectCities &&
										citiesByState != null
								"
								sm="5"
								class="content-left"
							>
								<div role="group" class="form-group">
									<label for="cities">Ciudades</label>
									<multiselect
										@select="changeSelectCities"
										:multiple="optionsSelectCities.multiple"
										v-model="selectedCitie"
										track-by="codigociudad"
										label="nombreciudad"
										:options="citiesByState"
										:searchable="true"
										:close-on-select="true"
										:show-labels="false"
										:allow-empty="true"
										placeholder="Seleccione"
									>
										<span slot="noResult"
											>Oops! No se encontró la opción
											deseada</span
										>
									</multiselect>
								</div>
							</CCol>
							<!-- select para las urbanizaciones -->
							<CCol
								v-if="
									optionsSelectUrbanizations.showSelectUrbanizations &&
										urbanizationByCity != null
								"
								sm="5"
								class="content-left"
							>
								<div role="group" class="form-group">
									<label for="cities">Urbanizaciones</label>
									<multiselect
										:multiple="
											optionsSelectUrbanizations.multiple
										"
										v-model="selectedUrbanization"
										track-by="idUrbanization"
										label="nameUrbanization"
										:options="urbanizationByCity"
										:searchable="true"
										:close-on-select="false"
										:show-labels="false"
										:allow-empty="true"
										placeholder="Seleccione"
									>
										<span slot="noResult"
											>Oops! No se encontró la opción
											deseada</span
										>
									</multiselect>
								</div>
							</CCol>
						</CRow>
						<!-- boton ver detalles del envio -->
						<CRow v-if="showButtonForDetail" class="content-center">
							<CCol sm="12">
								<b-button
									@click="clickShowDetail"
									title="Detalle del envío"
									id="detailRequest"
									pill
									variant="info"
								>
									Ver detalle del envío
								</b-button>
							</CCol>
						</CRow>
						<!-- mensaje -->
						<!-- <CRow v-if="selectedMethodRequest!=null" class="content-center">
                            <CCol v-if="selectedMethodRequest.typeCod=='A'" sm="12" class="content-left">
                                <p>Crearás un envío masivo <b>Nacional</b> para la
                                    categoría <b>{{selectedCategorie.nombrecategoria}}</b>
                                    la cual cuenta con la cantidad de <b>1200</b> empresas
                                </p>
                                <p>Si esta información es correcta por favor haz clic en el siguiente botón para
                                    programar
                                    en el envío masivo las <b>1200</b> empresas de la categoría
                                    <b>{{selectedCategorie.nombrecategoria}}</b>.</p>
                            </CCol>
                        </CRow> -->
					</CCardBody>
				</CCard>
			</CCol>
			<!-- detalles del envio -->
			<CCol v-if="showDetail" sm="12" class="">
				<CCard>
					<CCardHeader style="background: #97ca3d; color: black;">
						<h3>
							Detalle del Envío
						</h3>
					</CCardHeader>
					<CCardBody>
						<div v-if="emailsQuantity > 0">
							<CRow v-if="selectedMethodRequest.typeCod == 'A'">
								<CCol sm="12" class="content-left">
									<p>
										Crearás un envío masivo
										<b>Nacional</b> para la categoría
										<b>{{
											selectedCategorie.nombrecategoria
										}}</b>
										la cual cuenta con la cantidad de
										<b>{{ emailsQuantity }}</b> empresas
									</p>
									<p>
										Si esta información es correcta por
										favor has clic en el siguiente botón
										para programar en el envío masivo las
										<b>{{ emailsQuantity }}</b> empresas de
										la categoría
										<b>{{
											selectedCategorie.nombrecategoria
										}}</b
										>.
									</p>
								</CCol>
							</CRow>
							<CRow v-else>
								<CCol sm="12">
									<p>
										El envío
										<b>{{
											selectedMethodRequest != null
												? selectedMethodRequest.nameType
												: ''
										}}</b>
										para la categoría
										<b>{{
											selectedCategorie.nombrecategoria
										}}</b>
										presenta el siguiente detalle
									</p>
								</CCol>
							</CRow>
							<CRow v-if="detailTable.length > 0">
								<CCol sm="12">
									<b-table
										stacked="lg"
										striped
										outlined
										hover
										bordered
										:items="detailTable"
										:fields="fieldsDetailsTable"
									>
									</b-table>
								</CCol>
							</CRow>
							<CRow>
								<CCol sm="12">
									<ValidationObserver
										ref="observer"
										v-slot="{ invalid }"
									>
										<ValidationProvider
											name="Descripción"
											rules="required|min:3"
											v-slot="{ valid, touched, errors }"
										>
											<CTextarea
												v-model="descriptionRequest"
												id="address"
												label="Descripción"
												vertical
												rows="10"
												description="Ingresa una descripción para el envío"
												:isValid="
													touched && !valid
														? valid
														: touched && valid
														? valid
														: null
												"
											>
												<template #invalid-feedback>
													<span
														class="invalid-feedback"
														>{{errors[0]}}
													</span>
												</template>
											</CTextarea>
										</ValidationProvider>
									</ValidationObserver>
								</CCol>
							</CRow>
							<CRow
								v-if="showButtonForDetail"
								class="content-center"
							>
								<CCol sm="6">
									<b-button
										@click="showDetail = false"
										title="Cambiar datos para el envío"
										pill
										variant="info"
									>
										Cambiar datos para el envío
									</b-button>
								</CCol>
								<CCol sm="6">
									<b-button
										@click="scheduleRequest"
										title="Programar envío"
										pill
										variant="success"
										:disabled="
											descriptionRequest === ''
												? true
												: false
										"
									>
										Programar envío
									</b-button>
								</CCol>
							</CRow>
						</div>
						<div v-else>
							<CRow v-if="selectedMethodRequest.typeCod == 'A'">
								<CCol sm="12" class="content-left">
									<p>
										No es posible programar un env&iacute;o
										<b>Nacional</b> para la categor&iacute;a
										<b>{{
											selectedCategorie.nombrecategoria
										}}</b
										>, ya que no existen empresas
										registradas.
									</p>
								</CCol>
							</CRow>
							<CRow v-else>
								<CCol sm="12">
									<p>
										No es posible programar un env&iacute;o
										<b>{{
											selectedMethodRequest != null
												? selectedMethodRequest.nameType
												: ''
										}}</b>
										para la categoría
										<b>{{
											selectedCategorie.nombrecategoria
										}}</b
										>, ya que no existen empresas
										registradas.
									</p>
								</CCol>
							</CRow>
							<CRow class="content-center">
								<CCol sm="6">
									<b-button
										@click="showDetail = false"
										title="Cambiar datos para el envío"
										pill
										variant="info"
									>
										Cambiar datos para el envío
									</b-button>
								</CCol>
							</CRow>
						</div>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>
		<!-- modal de confirmacion al guardar exitosamente -->
		<CModal
			:show.sync="modalSuccessSend"
			:close-on-backdrop="false"
			:centered="true"
			title="Envío programado exitosamente!!"
			size="lg"
			color="success"
			style="text-align:justify;"
		>
			<CRow>
				<CCol>
					<span
						>Bien hecho!! programaste un envío masivo
						<b>{{
							selectedMethodRequest != null
								? selectedMethodRequest.nameType
								: ''
						}}</b>
						para la categoría
						<b>{{
							selectedCategorie != null
								? selectedCategorie.nombrecategoria
								: ''
						}}</b></span
					>
				</CCol>
			</CRow>
			<br />
			<CRow>
				<CCol>
					<span>
						Se le enviará la solicitud para actualizar su datos a un
						total de <b>{{ emailsQuantity }}</b>
						empresas.
					</span>
				</CCol>
			</CRow>
			<br />
			<CRow>
				<CCol>
					<span>
						El envío se realizará el día de mañana a partir de las 8
						de la mañana.
					</span>
				</CCol>
			</CRow>
			<br />
			<template #header>
				<h6 class="modal-title">Envío programado exitosamente!!</h6>
				<CButtonClose @click="goToMassiveRequests" class="text-white" />
			</template>
			<template #footer>
				<b-button
					@click="goToMassiveRequests"
					pill
					variant="success"
					size="lg"
					class="mr-1"
					>Cerrar
				</b-button>
			</template>
		</CModal>
	</div>
</template>
<script>
	import functionsForRequests from '../../functions/functionsForRequests';
	import '../../validations/validationsForm';
	export default {
		/** Componente para el modulo de envíos masivos usado para crear un envío masivo */
		name: 'createMasiveRequest',
		title: 'Crear Solicitud Masiva | Infoguia',
		beforeCreate: function() {},
		created() {
			let loader = this.$loading.show();
			functionsForRequests
				.allCategories()
				.then((responseCategories) => {
					this.allCategories = responseCategories;
					functionsForRequests
						.allStates()
						.then((responseStates) => {
							this.allStates = responseStates;
						})
						.catch((errorStates) => {
							console.log(errorStates);
						})
						.finally(() => {
							loader.hide();
						});
				})
				.catch((errorCategories) => {
					console.log(errorCategories);
				});
		},
		data() {
			return {
				showProcessExplanation: false,
				methodMasiveRequest: [
					{
						typeCod: 'A',
						nameType: 'Nacional',
					},
					{
						typeCod: 'S',
						nameType: 'Por Estado',
					},
					{
						typeCod: 'C',
						nameType: 'Por Ciudad',
					},
					{
						typeCod: 'U',
						nameType: 'Por Urbanización',
					},
				],
				selectedMethodRequest: null,
				allCategories: null,
				selectedCategorie: null,
				allStates: null,
				selectedState: null,
				citiesByState: null,
				selectedCitie: null,
				urbanizationByCity: null,
				selectedUrbanization: null,
				optionsSelectStates: {
					showSelectStates: false,
					multiple: true,
				},
				optionsSelectCities: {
					showSelectCities: false,
					multiple: true,
				},
				optionsSelectUrbanizations: {
					showSelectUrbanizations: false,
					multiple: true,
				},
				showDetail: false,
				fieldsDetailsTable: [],
				detailTable: [],
				buttonShowDetail: false,
				descriptionRequest: '',
				objForPost: {},
				emailsQuantity: 0,
				modalSuccessSend: false,
			};
		},
		methods: {
			changeMethodMasiveEmail(selectedMethod) {
				console.log(selectedMethod);
				let typeCod = selectedMethod.typeCod;
				switch (typeCod) {
					case 'A':
						//reinicio de campos
						this.optionsSelectStates.showSelectStates = false;
						this.optionsSelectCities.showSelectCities = false;
						this.optionsSelectUrbanizations.showSelectUrbanizations = false;
						this.citiesByState = null;
						this.urbanizationByCity = null;
						this.selectedState = null;
						this.selectedCitie = null;
						this.selectedUrbanization = null;
						this.objForPost = {};
						this.detailTable = [];
						break;
					case 'S':
						//reinicio de campos
						this.selectedCitie = null;
						this.selectedUrbanization = null;
						this.selectedState = null;
						this.optionsSelectCities.showSelectCities = false;
						this.optionsSelectCities.multiple = true;
						this.optionsSelectUrbanizations.showSelectUrbanizations = false;
						this.objForPost = {};
						//datos para el select de estados
						this.optionsSelectStates.showSelectStates = true;
						this.optionsSelectStates.multiple = true;
						break;
					case 'C':
						//reinicio de camps
						this.selectedState = null;
						this.selectedCitie = null;
						this.citiesByState = null;
						this.selectedUrbanization = null;
						this.optionsSelectUrbanizations.showSelectUrbanizations = false;
						this.objForPost = {};
						// datos para los selects de estado
						this.optionsSelectStates.showSelectStates = true;
						this.optionsSelectStates.multiple = false;
						// datos para el select de ciudades
						this.optionsSelectCities.showSelectCities = true;
						this.optionsSelectCities.multiple = true;
						break;
					case 'U':
						// reinicio de campops
						this.selectedState = null;
						this.selectedCitie = null;
						this.selectedUrbanization = null;
						this.citiesByState = null;
						this.urbanizationByCity = null;
						this.objForPost = {};
						// datos para los selects de estado y ciudad
						this.optionsSelectStates.showSelectStates = true;
						this.optionsSelectStates.multiple = false;
						this.optionsSelectCities.showSelectCities = true;
						this.optionsSelectCities.multiple = false;
						// datos para el select de urbanizaciones
						this.optionsSelectUrbanizations.showSelectUrbanizations = true;
						this.optionsSelectUrbanizations.multiple = true;
						break;
					default:
						break;
				}
			},
			clickShowDetail() {
				let codTypeRequest = this.selectedMethodRequest.typeCod;
				let loader = this.$loading.show();
				this.showDetail = true;
				switch (codTypeRequest) {
					case 'A':
						this.objForPost = {
							locationSent: codTypeRequest,
							idcountries: 1,
							process: 'CP',
							idcategory: this.selectedCategorie.codigocategoria,
						};
						functionsForRequests
							.consultQuantBussiness(this.objForPost)
							.then((responseQuant) => {
								//console.log(responseQuant)
								this.emailsQuantity = responseQuant;
							})
							.catch((errorQuantity) => {
								console.log(errorQuantity);
							})
							.finally(() => {
								loader.hide();
							});
						break;
					case 'S':
						let cantStates = this.selectedState.length;
						let statesArray = this.selectedState.map(function(obj) {
							return obj.codigoestado;
						});
						this.fieldsDetailsTable = [
							{
								key: 'state',
								label: 'Estados',
							},
							{
								key: 'cantStates',
								label: 'Cantidad de Estados',
							},
							{
								key: 'cantBussines',
								label: 'Total de Empresas',
							},
						];
						this.objForPost = {
							locationSent: codTypeRequest,
							idcountries: 1,
							process: 'CP',
							idstate: statesArray,
							idcategory: this.selectedCategorie.codigocategoria,
						};
						functionsForRequests
							.consultQuantBussiness(this.objForPost)
							.then((responseQuant) => {
								//console.log(responseQuant)
								this.emailsQuantity = responseQuant;
								if (cantStates == 1) {
									this.detailTable = [
										{
											state: this.selectedState[0]
												.nombreestado,
											cantStates: cantStates,
											cantBussines: responseQuant,
										},
									];
								} else if (cantStates > 1) {
									let statesString = '';
									for (
										let index = 0;
										index < this.selectedState.length;
										index++
									) {
										statesString +=
											this.selectedState[index]
												.nombreestado + ', ';
									}
									this.detailTable = [
										{
											state: statesString
												.trim()
												.slice(0, -1),
											cantStates: cantStates,
											cantBussines: responseQuant,
										},
									];
								}
							})
							.catch((errorQuantity) => {
								console.log(errorQuantity);
							})
							.finally(() => {
								loader.hide();
							});
						break;
					case 'C':
						let cantCities = this.selectedCitie.length;
						let citiesArray = this.selectedCitie.map(function(obj) {
							return obj.codigociudad;
						});
						this.fieldsDetailsTable = [
							{
								key: 'state',
								label: 'Estado',
							},
							{
								key: 'cities',
								label: 'Ciudades',
							},
							{
								key: 'cantCities',
								label: 'Cantidad de Ciudades',
							},
							{
								key: 'cantBussines',
								label: 'Cantidad de Empresas',
							},
						];
						this.objForPost = {
							locationSent: codTypeRequest,
							idcountries: 1,
							process: 'CP',
							idstate: this.selectedState.codigoestado,
							idcity: citiesArray,
							idcategory: this.selectedCategorie.codigocategoria,
						};
						functionsForRequests
							.consultQuantBussiness(this.objForPost)
							.then((responseQuant) => {
								//console.log(responseQuant)
								this.emailsQuantity = responseQuant;
								if (cantCities == 1) {
									this.detailTable = [
										{
											state: this.selectedState
												.nombreestado,
											cities: this.selectedCitie[0]
												.nombreciudad,
											cantCities: cantCities,
											cantBussines: responseQuant,
										},
									];
								} else if (cantCities > 1) {
									let citiesString = '';
									for (
										let index = 0;
										index < this.selectedCitie.length;
										index++
									) {
										citiesString +=
											this.selectedCitie[index]
												.nombreciudad + ', ';
									}
									this.detailTable = [
										{
											state: this.selectedState
												.nombreestado,
											cities: citiesString
												.trim()
												.slice(0, -1),
											cantCities: cantCities,
											cantBussines: responseQuant,
										},
									];
								}
							})
							.catch((errorQuantity) => {
								console.log(errorQuantity);
							})
							.finally(() => {
								loader.hide();
							});
						break;
					case 'U':
						let cantUrb = this.selectedUrbanization.length;
						let urbArray = this.selectedUrbanization.map(function(
							obj
						) {
							return obj.idUrbanization;
						});
						this.fieldsDetailsTable = [
							{
								key: 'state',
								label: 'Estado',
							},
							{
								key: 'city',
								label: 'Ciudad',
							},
							{
								key: 'urb',
								label: 'Urbanizaciones',
							},
							{
								key: 'cantUrb',
								label: 'Cantidad de Urbanizaciones',
							},
							{
								key: 'cantBussines',
								label: 'Cantidad de Empresas',
							},
						];
						this.objForPost = {
							locationSent: codTypeRequest,
							idcountries: 1,
							process: 'CP',
							idstate: this.selectedState.codigoestado,
							idcity: this.selectedCitie.codigociudad,
							idcategory: this.selectedCategorie.codigocategoria,
							idurbanization: urbArray,
							typeUrbanization: 'PRINCIPAL',
						};
						functionsForRequests
							.consultQuantBussiness(this.objForPost)
							.then((responseQuant) => {
								//console.log(responseQuant)
								this.emailsQuantity = responseQuant;
								if (cantUrb == 1) {
									this.detailTable = [
										{
											state: this.selectedState
												.nombreestado,
											city: this.selectedCitie
												.nombreciudad,
											urb: this.selectedUrbanization[0]
												.nameUrbanization,
											cantUrb: cantUrb,
											cantBussines: responseQuant,
										},
									];
								} else if (cantUrb > 1) {
									let urbString = '';
									for (
										let index = 0;
										index <
										this.selectedUrbanization.length;
										index++
									) {
										urbString +=
											this.selectedUrbanization[index]
												.nameUrbanization + ', ';
									}
									this.detailTable = [
										{
											state: this.selectedState
												.nombreestado,
											city: this.selectedCitie
												.nombreciudad,
											urb: urbString.trim().slice(0, -1),
											cantUrb: cantUrb,
											cantBussines: responseQuant,
										},
									];
								}
							})
							.catch((errorQuantity) => {
								console.log(errorQuantity);
							})
							.finally(() => {
								loader.hide();
							});
						break;
				}
			},
			changeSelectState(selectedState) {
				let idState = selectedState.codigoestado;
				let codTypeRequest = this.selectedMethodRequest.typeCod;
				switch (codTypeRequest) {
					case 'C': //ciudades
					case 'U': //urbanizaciones
						let loader = this.$loading.show();
						this.selectedCitie = null;
						functionsForRequests
							.citiesByState(idState)
							.then((responseCities) => {
								this.citiesByState = responseCities;
							})
							.catch((errorCities) => {
								console.log(errorCities);
							})
							.finally(() => {
								loader.hide();
							});
						break;
					// case 'S':
					//     this.buttonShowDetail = true
					//     break;
					default:
						break;
				}
			},
			changeSelectCities(selectedCity) {
				let idCity = selectedCity.codigociudad;
				let codTypeRequest = this.selectedMethodRequest.typeCod;
				switch (codTypeRequest) {
					case 'U': //urbanizacines
						let loader = this.$loading.show();
						functionsForRequests
							.urbanizationsByCity(idCity)
							.then((responseUrbanizations) => {
								this.urbanizationByCity = responseUrbanizations;
							})
							.catch((errorUrbanizations) => {
								console.log(errorUrbanizations);
							})
							.finally(() => {
								loader.hide();
							});
						break;
					case 'C':
						this.buttonShowDetail = true;
						break;
					default:
						break;
				}
			},
			async scheduleRequest() {
				const isValid = await this.$refs.observer.validate();
				if (isValid) {
					let loader = this.$loading.show();
					this.objForPost.process = 'PC';
					this.objForPost.description = this.descriptionRequest;
					functionsForRequests
						.scheduleRequest(this.objForPost)
						.then((responseSchedule) => {
							//console.log(responseSchedule)
							this.modalSuccessSend = true;
						})
						.catch((errorSchedule) => {
							console.log(errorSchedule);
						})
						.finally(() => {
							loader.hide();
						});
				}
			},
			goToMassiveRequests() {
				this.$router.push({
					name: 'ConsultRequests',
				});
			},
		},
		computed: {
			showButtonForDetail: function() {
				if (this.selectedMethodRequest != null) {
					let codTypeRequest = this.selectedMethodRequest.typeCod;
					switch (codTypeRequest) {
						case 'S':
							if (this.selectedState != null) {
								if (this.selectedState.length >= 1) {
									return (this.buttonShowDetail = true);
								}
							}
							break;
						case 'C':
							if (this.selectedCitie != null) {
								if (this.selectedCitie.length >= 1) {
									return (this.buttonShowDetail = true);
								}
							}
							break;
						case 'U':
							if (this.selectedUrbanization != null) {
								if (this.selectedUrbanization.length >= 1) {
									return (this.buttonShowDetail = true);
								}
							}
							break;
						case 'A':
							return (this.buttonShowDetail = true);
					}
				}
				return (this.buttonShowDetail = false);
			},
		},
	};
</script>
